import ContentContainer from "layout/Content/ContentContainer";
import Button from "components/ui/Button/Button";
import Trans from "features/translation/components/Trans";
import { useHistory } from "react-router-dom";

const PageNotFound = () => {
  const history = useHistory();

  return (
    <ContentContainer contentGridType={ 'small' }
                      contentBackground={ true }
                      contentPadding={ true }
                      containerPadding={ true }>
      <h1>
        <Trans text={ 'Oeps...' }/>
      </h1>
      <p>
        <Trans text={ 'De opgevraagde pagina kan niet gevonden worden.' }/>
      </p>

      <Button variant={ 'primary' } onClick={ () => history.push('/') }>
        <Trans text={'Ga naar homepage'} />
      </Button>
    </ContentContainer>
  )
}

export default PageNotFound;
